import React from 'react'

interface CalendarIconProps {
  size?: number
  color?: string
}

const CalendarIcon: React.FC<CalendarIconProps> = ({ size = 25, color }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.6667 2H11.3333V1.33333C11.3333 0.966667 11.0333 0.666667 10.6667 0.666667C10.3 0.666667 10 0.966667 10 1.33333V2H6V1.33333C6 0.966667 5.7 0.666667 5.33333 0.666667C4.96667 0.666667 4.66667 0.966667 4.66667 1.33333V2H3.33333C2.6 2 2 2.6 2 3.33333V13.3333C2 14.0667 2.6 14.6667 3.33333 14.6667H12.6667C13.4 14.6667 14 14.0667 14 13.3333V3.33333C14 2.6 13.4 2 12.6667 2ZM12 13.3333H4C3.63333 13.3333 3.33333 13.0333 3.33333 12.6667V5.33333H12.6667V12.6667C12.6667 13.0333 12.3667 13.3333 12 13.3333Z'
      fill={color || 'currentColor'}
    />
  </svg>
)

export default CalendarIcon
